import React, { useState } from "react";
import { useCreateSubDispositionMutation } from "../../../../Services/general/General";
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";

interface IProps {
  closeModal: () => void;
  selectedTeam: any;
  refetch: any;
}

const AddNewDispositionModal: React.FC<IProps> = ({
  closeModal,
  selectedTeam,
  refetch,
}) => {
  const [topic, setTopic] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [trigger, {isLoading}] = useCreateSubDispositionMutation();



  const handleAdd = async () => {
    const trimmedTopic = topic.trim();
    if (!trimmedTopic) {
      toast.error("Topic cannot be empty.");
      return;
    }
    setIsSubmitting(true);
    const payload = {
      topic: trimmedTopic,
      priority: "low",
      ticket_name: null,
      team: selectedTeam,
      hide: false,
      tn_parent: null,
    };
    try {
      const response = await trigger({
        body: payload,
        id: selectedTeam,
      });
      if (response && response.data) {
        toast.success("Added successfully");
        refetch();
        setTopic("");
        closeModal();
      } else {
        toast.error("Failed to add. Please try again.");
      }
    } catch (error: any) {
      toast.error(error?.data?.message || error?.message || "An error occurred while adding disposition");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div>
      <div className="mt-4">
        <input
          type="text"
          className="form-control"
          placeholder="Topic"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          disabled={isSubmitting} // Disable input while submitting
        />
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button
          type="reset"
          className="btn btn-sm btn-white text-hover-danger me-4"
          onClick={closeModal}
          disabled={isSubmitting} // Disable button while submitting
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleAdd}
          disabled={!topic.trim() || isSubmitting} // Disable button if topic is empty or submitting
        >
          {isLoading ? <>Adding... <Loader /></> : "Add"}
        </button>
      </div>
    </div>
  );
};

export default AddNewDispositionModal;
